import { createAction } from '@reduxjs/toolkit';

export const LEAVE_CONVERSATION_ACTION_TYPE = 'saga/leaveConversation';
export const leaveConversationAction = createAction(LEAVE_CONVERSATION_ACTION_TYPE);
